export const UPLOAD_FILE_CODE = {
  listing: {
    application: 'ecom',
    module: 'listing',
    function: 'listing',
  },
} as const;

export const IMAGE_EXTENSIONS = ['apng', 'avif', 'gif', 'jpg', 'jpeg', 'jfif', 'pjpeg', 'pjp', 'png', 'svg', 'webp'];
